<template>
	<div class="user-widget clearfix">
		<div class="avatar float-left mr-4" :style="avatarStyle"></div>
		<div>
			<p class="mb-0"><strong>{{ $UserSession.getValue("displayName") }}</strong></p>
			<p class="mb-0">
				<router-link to="/settings">{{ $t("settings") }}</router-link> |
				<a href="" @click="logOut">{{ $t("log-out") }}</a>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserWidget",
	props: {},
	methods: {
		logOut(e){
			this.$root.$emit('logOut', e);
		}
	},
	computed: {

		avatarStyle() {

			const url = `${this.$settings.APIBaseURL}/asset/avatar/${this.$UserSession.getValue('id')}?username=${this.$UserSession.getValue("username")}&authToken=${this.$UserSession.getValue("authToken")}`;

			return `background-image: url(${url})`;
		}
	}
};
</script>
